import { Injectable } from "@angular/core";
import {IndividualConfig, ToastrService} from "ngx-toastr";

export interface ToasterConfig extends IndividualConfig {}

@Injectable({
  providedIn: 'root'
})
export class ToasterService {
  private readonly TOASTER_TIMEOUT = 8000;

  constructor(private toastr: ToastrService) { }

  success(title?: string, message?: string) {
    this.toastr.success(message, title, {timeOut: this.TOASTER_TIMEOUT});
  }

  error(title?: string, message?: string) {
    this.toastr.error(message, title, {timeOut: this.TOASTER_TIMEOUT});
  }

  warning(title?: string, message?: string) {
    this.toastr.warning(message, title, {timeOut: this.TOASTER_TIMEOUT});
  }

  info(title?: string, message?: string) {
    this.toastr.info(message, title, {timeOut: this.TOASTER_TIMEOUT});
  }
}
